import { IconType } from "./icons.types";

export const RolesIcon = ({ className, color = "#000000" }: IconType) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.98093 18.3332H13.9482C15.8721 18.3332 17.4318 16.8448 17.4318 15.0088V10.944C17.4318 10.3538 17.6775 9.78783 18.1148 9.3705C19.1281 8.40359 18.9963 6.80154 17.8375 5.99727L12.5135 2.30233C11.292 1.45456 9.63712 1.45456 8.41559 2.30233L3.09165 5.99727C1.93278 6.80154 1.80106 8.40359 2.8143 9.3705C3.25162 9.78783 3.49731 10.3538 3.49731 10.944V15.0088C3.49731 16.8448 5.05698 18.3332 6.98093 18.3332Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8181 8.33317H10.111C9.72051 8.33317 9.40395 8.63165 9.40395 8.99984C9.40395 9.42118 8.95314 9.68905 8.58307 9.4876L8.54549 9.46715C8.2073 9.28305 7.77486 9.3923 7.57961 9.71116L7.22607 10.2885C7.03082 10.6074 7.14669 11.0151 7.48488 11.1992C7.85511 11.4007 7.85512 11.9323 7.48489 12.1338C7.1467 12.3179 7.03083 12.7256 7.22608 13.0445L7.57962 13.6218C7.77487 13.9407 8.20731 14.05 8.5455 13.8659L8.58308 13.8454C8.95314 13.644 9.40395 13.9118 9.40395 14.3332C9.40395 14.7014 9.72051 14.9998 10.111 14.9998H10.8181C11.2086 14.9998 11.5252 14.7014 11.5252 14.3332C11.5252 13.9118 11.976 13.644 12.346 13.8454L12.3836 13.8659C12.7218 14.05 13.1542 13.9407 13.3495 13.6218L13.703 13.0445C13.8983 12.7256 13.7824 12.3179 13.4442 12.1338C13.074 11.9323 13.074 11.4007 13.4442 11.1992C13.7824 11.0151 13.8983 10.6074 13.703 10.2885L13.3495 9.71116C13.1543 9.3923 12.7218 9.28305 12.3836 9.46715L12.346 9.48761C11.976 9.68905 11.5252 9.42118 11.5252 8.99984C11.5252 8.63165 11.2086 8.33317 10.8181 8.33317Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0895 11.6665C11.0895 12.0117 10.8097 12.2915 10.4645 12.2915C10.1194 12.2915 9.83954 12.0117 9.83954 11.6665C9.83954 11.3213 10.1194 11.0415 10.4645 11.0415C10.8097 11.0415 11.0895 11.3213 11.0895 11.6665Z"
        fill="#28303F"
      />
    </svg>
  );
};
